import React from 'react';
import './Header.css';
import  unvrLogo from '../../assets/header/unvr-logo.png';
import langLogo from '../../assets/header/language-logo.svg';
import flag from '../../assets/header/flag.png';
import gerb from '../../assets/header/gerb.png';
import madhiya from '../../assets/header/madhiya.png';
import Navbar from './Navbar/Navbar';
import { useNavigate ,Link} from 'react-router-dom';


const  Header=()=>{
const navigate=useNavigate()

  return (
    <div className="header">
      <div className='header__top'>
        <div className='header__top-left'>
         <Link to="/"><img src={unvrLogo} className="logo" alt="University logo" /></Link> 
          <h5 className='header__top-left__title'>Amaliy matematika va intelektual texnologiyalar fakulteti</h5>
        </div>
        <div className='header__top-right'>
         <div className='ramz'>
           <img src={flag} alt="Flag" onClick={()=>navigate('ramz/bayroq')} />
           <img src={gerb} alt="Gerb" onClick={()=>navigate('ramz/gerb')} />
           <img src={madhiya} alt="Madhiya"  onClick={()=>navigate('ramz/madhiya')}/>
          </div> 
          <div className='language'>
            <img src={langLogo} className='language-logo' alt="" />
            
            <select name="title" id="">
              <option value="uz" ><p>O'zbek</p></option>
              <option value="eng"><p> English</p></option>
              <option value="rus"><p> Russian</p></option>
            </select>
          </div>
          <div className='number'>
           <p className='number-title'>+71 123-45-67</p>
          </div>
        </div>

      </div>
      <div className='line1'></div>
      <div className='header__navbar'>
        <Navbar/>
      </div>
    </div>
  )
}
export default Header
